import styled from '@emotion/styled';
import { Fonts, Spacings } from '@styles/index';
import React, { useEffect } from 'react';
import EmptyProfileIcon from '@icon/Groups/EmptyProfile';
import { GroupsContext } from '@context/GroupsContext';
import GroupsProfileTrigger from '../CommonCards/groupsProfile/GroupsProfileTrigger';
import GroupProfilePopup, {
  IGroupProfilePopupFn
} from '../CommonCards/groupsProfile/GroupProfilePopup';
import GroupsUserAvatar from '../CommonCards/GroupsUserAvatar';

interface IBlah {
  length: number;
}
const UsersAvatarRow = styled.div<IBlah>`
  display: flex;
  gap: ${Spacings.SPACING_6};
  justify-content: space-between;
`;

const CountAvatar = styled.div`
  height: ${Spacings.SPACING_10B};
  width: ${Spacings.SPACING_10B};
  background-color: var(--color-base-light-0);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

const CountText = styled.span`
  font-size: ${Fonts.SMALL};
  color: var(--color-text-secondary);
  font-weight: ${Fonts.BOLD};
`;

const EmptyProfile = styled.div`
  height: ${Spacings.SPACING_10B};
  width: ${Spacings.SPACING_10B};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: var(--color-base-light-0);
  border-radius: 50%;
`;

interface IGroupProfileRowProps {
  goalUID: string;
  isDrawerVisible: boolean;
  onProfileClick: () => void;
  addInviteCard: () => void;
  closeDrawer: () => void;
}

const GroupProfleRow: React.FC<IGroupProfileRowProps> = ({
  goalUID,
  isDrawerVisible,
  onProfileClick,
  addInviteCard,
  closeDrawer
}) => {
  const popupRef = React.useRef<IGroupProfilePopupFn>();
  const groupsContext = React.useContext(GroupsContext);
  const { users: usersList } = groupsContext;
  const usersLength = usersList.length;
  const extraUsersCount = usersLength - 6;
  const emptyProfileCount = 6 - usersLength;
  const filteredUsers = extraUsersCount
    ? usersList.slice(0, 5)
    : usersList.slice(0, 6);

  const handleShowPopup = (targetUser) => (event) => {
    popupRef.current?.handleShowPopup(event, targetUser);
  };

  const handleClosePopup = () => {
    popupRef.current?.handleHidePopup();
  };

  useEffect(() => {
    if (isDrawerVisible) {
      handleClosePopup();
      popupRef.current = null;
    }
  }, [isDrawerVisible]);

  return (
    <GroupProfilePopup
      goalUID={goalUID}
      ref={popupRef}
      closeDrawer={closeDrawer}
      direction="bottom"
    >
      <UsersAvatarRow length={usersLength}>
        {filteredUsers.map((user) => (
          <GroupsProfileTrigger
            key={user.uid}
            onClick={handleShowPopup(user)}
            onHidePopup={handleClosePopup}
          >
            <GroupsUserAvatar user={user} length={usersLength} />
          </GroupsProfileTrigger>
        ))}
        {emptyProfileCount > 0 &&
          [...Array(emptyProfileCount).keys()].map((key) => (
            <EmptyProfile key={key} onClick={addInviteCard}>
              <EmptyProfileIcon
                viewBox="0 0 24 24"
                size={24}
                color="var(--color-text-secondary-light)"
              />
            </EmptyProfile>
          ))}
        {extraUsersCount > 0 && (
          <CountAvatar onClick={onProfileClick}>
            <CountText>{`+${usersLength - 5}`}</CountText>
          </CountAvatar>
        )}
      </UsersAvatarRow>
    </GroupProfilePopup>
  );
};

export default GroupProfleRow;
